var NoApproverController = (function () {
    function NoApproverController() {
    }
    return NoApproverController;
}());
var NoApproverComponent = (function () {
    function NoApproverComponent() {
        this.templateUrl = 'noapprover.html';
        this.controllerAs = 'vm';
        this.controller = NoApproverController;
    }
    return NoApproverComponent;
}());
angular
    .module('application')
    .component('noApproverSection', new NoApproverComponent());

//# sourceMappingURL=noapprover.js.map
